/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscogsReleaseTracklistTracksInnerSubtracksInner
 */
export interface DiscogsReleaseTracklistTracksInnerSubtracksInner {
    /**
     * 1-based position in the raw Discogs sub-track list.
     * @type {number}
     * @memberof DiscogsReleaseTracklistTracksInnerSubtracksInner
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInnerSubtracksInner
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInnerSubtracksInner
     */
    position: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsReleaseTracklistTracksInnerSubtracksInner
     */
    duration: string;
}

/**
 * Check if a given object implements the DiscogsReleaseTracklistTracksInnerSubtracksInner interface.
 */
export function instanceOfDiscogsReleaseTracklistTracksInnerSubtracksInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "duration" in value;

    return isInstance;
}

export function DiscogsReleaseTracklistTracksInnerSubtracksInnerFromJSON(json: any): DiscogsReleaseTracklistTracksInnerSubtracksInner {
    return DiscogsReleaseTracklistTracksInnerSubtracksInnerFromJSONTyped(json, false);
}

export function DiscogsReleaseTracklistTracksInnerSubtracksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsReleaseTracklistTracksInnerSubtracksInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'title': json['title'],
        'position': json['position'],
        'duration': json['duration'],
    };
}

export function DiscogsReleaseTracklistTracksInnerSubtracksInnerToJSON(value?: DiscogsReleaseTracklistTracksInnerSubtracksInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'title': value.title,
        'position': value.position,
        'duration': value.duration,
    };
}

